import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllDevicesStartAsync } from "../redux/assets/assetsActions";
import { getAllGeofences } from "../redux/geofence/geofenceActions";

export const useDashboardData = () => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.currentUser);
  // Optionally, select loading/error states from Redux here too

  useEffect(() => {
    if (currentUser && currentUser.user && currentUser.token) {
      dispatch(getAllDevicesStartAsync(currentUser.user._id, currentUser.token));
      dispatch(getAllGeofences(currentUser.user._id, currentUser.token));
    }
  }, [dispatch, currentUser]);

  // return { isLoading, error }; // if you were managing those here or pulling from redux
}; 